import { MembersPage } from '@/features/members/pages/members-page';

const MembersRoute = () => {
  return <MembersPage />;
};

export default MembersRoute;
